import React from 'react'
import styles from './Skeleton.module.scss'

type SkeletonProps = {
    type: 'image' | 'table';
    rows?: number;
    width?: number | string;
    height?: number | string;
    radius?: number;
}

export const Skeleton: React.FC<SkeletonProps> = ({ type, rows = 5, width, height, radius = 6, }) => {
    if (type === 'image') {
        const style = {
            width: width || 256,
            height: height || 160,
            borderRadius: radius,
        }
        return (
            <div
                className={styles.SkeletonImageFade}
                role="img"
                aria-busy="true"
                aria-label="Loading image"
                aria-live="polite"
                aria-atomic="true"
                style={style}
            />
        )
    }

    if (type === 'table') {
        return (
            <div
                className={styles.SkeletonTableFade}
                aria-busy="true"
                aria-label="Loading table data"
                aria-live="polite"
                aria-atomic="true"
            >
                {[...Array(rows)].map((_, i) => (
                    <div key={i} className={styles.SkeletonRow}>
                        <div className={styles.SkeletonBoxSmall} aria-hidden="true"></div>
                        <div className={styles.SkeletonContent} aria-hidden="true">
                            <div className={styles.SkeletonLineShort}></div>
                            <div className={styles.SkeletonLineLong}></div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    return null
}
